<template>
<div>
    <div class="form form-horizontal">
        <h4>Prehistoric Artifacts</h4>
        <div class="col-md-4">
            <label>Chipped Stone</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 1})">
                    <form class="form-inline inline-container">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedList" v-bind:id="artifact.description" v-bind:value="artifact.artifactId">
                                <label v-bind:for="artifact.description">{{artifact.description}}</label>
                            </input>
                        </div>
                        <input class="form-control inline-input" type="textbox" style="width:60px" placeholder="count"
                                v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                                v-model="countList[artifact.artifactId]">
                        </input>
                    </form>
                </li>
            </ul>
            <!-- <div class="checkbox checkbox-inline">
                <input type="checkbox" v-model="selectedList" id="obsidianCB" v-bind:value="11">
                <label for="obsidianCB">&nbsp;</label>
            </div>
            <label for="obsidianCB">Obsidian</label>
            <br /> -->
            <label>Ground Stone</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 2})">
                    <form class="form-inline inline-container">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedList" v-bind:id="artifact.description" v-bind:value="artifact.artifactId">
                                <label v-bind:for="artifact.description">{{artifact.description}}</label>
                            </input>
                        </div>
                        <input class="form-control inline-input" type="textbox" style="width:60px" placeholder="count"
                            v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                            v-model="countList[artifact.artifactId]"></input>
                    </form>
                </li>
            </ul>
        </div>
        <div class="col-md-3">
            <label>Bone and Organic</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 4})">
                    <div class="checkbox checkbox-inline">
                        <input type="checkbox" v-model="selectedList" v-bind:id="artifact.description" v-bind:value="artifact.artifactId">
                            <label v-bind:for="artifact.description">{{artifact.description}}</label>
                        </input>
                    </div>
                </li>
            </ul>
            <label>Ceramics / Steatite</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId ===3})">
                    <form class="form-inline inline-container">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedList" v-bind:id="artifact.description" v-bind:value="artifact.artifactId">
                                <label v-bind:for="artifact.description">{{artifact.description}}</label>
                            </input>
                        </div>
                        <input class="form-control inline-input" type="textbox" style="width:60px" placeholder="count"
                            v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                            v-model="countList[artifact.artifactId]"></input>
                    </form>
                </li>
            </ul>
        </div>
        <div class="col-md-3">
            <label>Other Artifacts</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 5})">
                    <form class="form-inline inline-container">
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" v-model="selectedList" v-bind:id="artifact.description" v-bind:value="artifact.artifactId">
                                <label v-bind:for="artifact.description">{{artifact.description}}</label>
                            </input>
                        </div>
                        <input class="form-control inline-input" type="textbox" style="width:60px" placeholder="count"
                            v-show="artifact.hasCount && selectedList.includes(artifact.artifactId)"
                            v-model="countList[artifact.artifactId]"></input>
                    </form>
                </li>
            </ul>
            <label>Human Remains</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x=> {return x.artifactCategoryId === 6})">
                    <div class="checkbox checkbox-inline">
                        <input type="checkbox" v-model="selectedList" v-bind:id="artifact.description" v-bind:value="artifact.artifactId">
                            <label v-bind:for="artifact.description">{{artifact.description}}</label>
                        </input>
                    </div>
                </li>
            </ul>
        </div>
    </div>        
</div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import artifactService from '@/services/lookup/artifactService'

export default {
    name: 'PrehistoricArtifactSelection',
    components: {

    },
    data: function () {
        return {
            artifactList: [],
            selectedList: [],
            countList: []
        }
    },
    mounted () {
        this.log('Starting mount')
        this.loadData().then(result => {
            this.log('Done Loading')
        })
    },
    computed: {
        filteredSelectedList: function () {
            return this.selectedList.filter(x => {
                return this.artifactList.find(y => y.artifactId === x && y.timePeriodId < 3)
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Prehistoric Artifact Selection', message)
        },
        loadData () {
            return artifactService.listArtifact(this.$http).then(result => {
                this.artifactList = result.data.map(x => {
                    delete x.hasCount
                    return x
                })
                this.log('Found artifacts: ' + this.artifactList.length)
                return result
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// PrehistoricArtifactSelection.vue?03c8f582